import * as Buttons from '@app/text-content/button-templates';
import { ENTITY_TYPES, WIDGET_COMPONENT } from '@shared/types';
import { WIDGET_FAMILY } from '@config/global-constants';
import { MAX_GROUP_NAME_LENGTH_LIMIT } from '@app/shared/services/transfer-group/transfer-group.constants';
import { getEntityNameRequiredValidator } from '@app/shared/validators/entity-name-required.validator';
import { I18n } from '@app/i18n/strings-keys';
import { XVII18nService } from '@app/i18n/services';

export const MODAL_TEMPLATE_PROMPT = {
  modalType: 'prompt',
  title: I18n.Common.Prompt,
  buttons: [Buttons.BTN_DONE, Buttons.BTN_CANCEL],
  schema: {
    required: ['name'],
    properties: {
      name: { title: 'Name', type: 'string', minLength: 1 },
    },
  },
};

export const MODAL_TEMPLATE_CONFIRM = {
  modalType: 'confirm',
  title: I18n.Common.Confirm,
  buttons: [Buttons.BTN_YES, Buttons.BTN_CANCEL],
};

export const MODAL_TEMPLATE_ALERT = {
  modalType: 'alert',
  title: 'Information',
  buttons: [Buttons.BTN_OK],
};

export const MODAL_TEMPLATE_SITE_SELECTOR = {
  modalType: 'site-selector',
  title: 'Please Select Sites',
  validation: true,
  buttons: [
    {
      ...Buttons.BTN_DONE,
      caption: (formValue): string => {
        return formValue.sites.length <= 1
          ? 'Select Site'
          : `Select ${formValue.sites.length} Sites`;
      },
    },
    Buttons.BTN_BACK,
  ],
  schema: {
    type: 'object',
    properties: {
      sites: {
        type: 'array',
      },
    },
  },
  formRules: {
    fields: {
      sites: {
        widgetFamily: WIDGET_FAMILY.XUX,
        widget: WIDGET_COMPONENT.grid_list,
        widgetData: {
          gridHeight: '400px',
          showSearch: true,
          columns: [
            {
              title: 'Name',
              path: 'name',
              defaultView: true,
            },
          ],
        },
      },
    },
  },
};

export const MODAL_SAVE_AS_TEMPLATE_CONFIRM = (
  service,
  noSpecialCharactersRegex: string,
  i18nService?: XVII18nService,
) => ({
  modalType: 'confirm',
  title: I18n.Forms.TransferForm.SaveAsaTemplate,
  buttons: [Buttons.BTN_YES, Buttons.BTN_CANCEL],
  validation: true,
  schema: {
    required: ['name'],
    properties: {
      name: { title: 'Template Name', type: 'string', minLength: 1 },
    },
  },
  formRules: {
    fields: {
      name: {
        title: I18n.Forms.TransferForm.TemplateName,
        widgetFamily: WIDGET_FAMILY.XUX,
        widget: WIDGET_COMPONENT.input,
        required: true,
        widgetData: {
          placeholder: I18n.Forms.TransferForm.EnterTemplateName,
        },
        maxLength: MAX_GROUP_NAME_LENGTH_LIMIT,
        pattern: {
          value: noSpecialCharactersRegex,
          errorMessage: i18nService.translate(
            I18n.ErrorMessages.SpecialCharactersAreNotAllowed,
          ),
        },
        validators: [
          getEntityNameRequiredValidator(
            ENTITY_TYPES.TRANSFER_GROUP_TEMPLATE,
            service.i18nService,
          ),
        ],
        asyncValidators: [
          service.caseInsensitiveUniqueValidator(null, {
            include_active: true,
          }),
        ],
      },
    },
  },
});
